import { render, staticRenderFns } from "./LegendFilters.vue?vue&type=template&id=d4dcd734"
import script from "./LegendFilters.vue?vue&type=script&lang=js"
export * from "./LegendFilters.vue?vue&type=script&lang=js"
import style0 from "./LegendFilters.vue?vue&type=style&index=0&id=d4dcd734&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports